/* @generated from adl module ferovinum.sourcecontracts.paymentterms */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.payment_terms` contract.
 */
export interface PaymentTermsSource {
  id: ferovinum_app_db.PaymentTermsId;
  /**
   * 'daysAfterFulfillment' or 'endOfMonth' (a DB check constraint, not an ADL enum).
   */
  kind: string;
  /**
   * Days after fulfilment, or the month offset for endOfMonth.
   */
  value: number;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makePaymentTermsSource(
  input: {
    id: ferovinum_app_db.PaymentTermsId,
    kind: string,
    value: number,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): PaymentTermsSource {
  return {
    id: input.id,
    kind: input.kind,
    value: input.value,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const PaymentTermsSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.paymentterms","decl":{"annotations":[{"value":{"modelName":"source__app_db.payment_terms","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.payment_terms` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PaymentTermsId"}},"parameters":[]}},{"annotations":[{"value":"'daysAfterFulfillment' or 'endOfMonth' (a DB check constraint, not an ADL enum).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Days after fulfilment, or the month offset for endOfMonth.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PaymentTermsSource","version":{"kind":"nothing"}}};

export const snPaymentTermsSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.paymentterms", name:"PaymentTermsSource"};

export function texprPaymentTermsSource(): ADL.ATypeExpr<PaymentTermsSource> {
  return {value : {typeRef : {kind: "reference", value : snPaymentTermsSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.paymentterms.PaymentTermsSource" : PaymentTermsSource_AST
};
